class ScheduleSummaryView {


    constructor() {
        this.rootNode = $('.app-schedule-summary');
        this.firstName = $('.app-first-name');
        this.lastName = $('.app-last-name');
        this.email = $('.app-email');
        this.remainingStudyHrs = this.rootNode.find('.app-remaining-study-time');
        this.items = this.rootNode.find('.activity-list li').map(
            function (i, node) {
                return new ScheduleSummaryViewItem($(node));
            }
        )
    }

    updateRemainingStudyTime(hrs) {
        this.remainingStudyHrs.find('span').html('' + hrs + ' hour' + (hrs === 1 ? '' :'s'));
        this.remainingStudyHrs.find('img').hideIf(hrs > 0);
    }

    findItem(scheduleType) {
        let found = null;
        this.items.each(function (i, item) {
            if(item.scheduleType === scheduleType) {
                found = item;
            }
        });
        return found;
    }
}

class ScheduleSummaryViewItem {

    constructor(rootNode) {
        this.rootNode = rootNode;
        this.scheduleType = parseInt(this.rootNode.attr('data-schedule-type'));
    }

    update(hours) {
        this.rootNode.find('.time').find('strong').html('' + hours + 'h');
    }
}
